import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class JobService {
  async getJobFilters() {
    return (await fetchApi.get(`${URL}/job/filters`)).data;
  }

  async getJob(id) {
    return (await fetchApi.get(`${URL}/job/${id}`)).data;
  }

  async getAllJobs(params) {
    const filters = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");

    return (await fetchApi.get(`${URL}/job/list?${filters}`)).data;
  }

  async createJob(formData) {
    return (await fetchApi.postFormData(`${URL}/job`, formData)).data;
  }

  async updateJob(id, formData) {
    return (await fetchApi.patchFormData(`${URL}/job/${id}`, formData)).data;
  }

  async deleteJob(id) {
    return (await fetchApi.delete(`${URL}/job/${id}`)).data;
  }

  async getHistory(id, Type) {
    return (await fetchApi.get(`${URL}/job/history/${id}/${Type}`)).data;
  }
}
